import { NotificationAlert } from "../shared/models/NotificationAlert";
import { interval } from "rxjs";
export enum AlertType {
  Add,
  Success,
  Error,
  Warning,
}


export class AlertMessages {
  public static NotArray: NotificationAlert[] = [];
  public static NotInterval = interval(5000);
  public static IntervalSubscription;
  public static ShowErrors(Title: string, Message: string[], MessageType: AlertType) {
    var icon: string = "";
    var Alertclass: string = "";
    var Textcolor: string = "";
    switch (MessageType) {
      case AlertType.Add: {
        icon = "&#43;";
        Alertclass = "normal";
        Textcolor = "#333333";
        break;
      }
      case AlertType.Success: {
        icon = "&#10003";
        Alertclass = "green";
        Textcolor = "#46986B";
        break;
      }
      case AlertType.Error: {
        icon = "&#215;";
        Alertclass = "red";
        Textcolor = "#DC143C";
        break;
      }
      case AlertType.Warning: {
        icon = "&#33;";
        Alertclass = "warn";
        Textcolor = "#FFA809";
        break;
      }
    }
    Message.forEach(element => {
      var Alert: NotificationAlert = new NotificationAlert((Math.random() * 100000).toFixed(0), Title, element, icon, Alertclass, Textcolor)
      if (AlertMessages.NotArray.length < 1) {
        AlertMessages.SubscribeInterval();
      }
      AlertMessages.NotArray.push(Alert);
    });

  }

  public static Show(Title: string, Message: string, MessageType: AlertType) {
    var icon: string = "";
    var Alertclass: string = "";
    var Textcolor: string = "";
    switch (MessageType) {
      case AlertType.Add: {
        icon = "&#43;";
        Alertclass = "normal";
        Textcolor = "#333333";
        break;
      }
      case AlertType.Success: {
        icon = "&#10003";
        Alertclass = "green";
        Textcolor = "#46986B";
        break;
      }
      case AlertType.Error: {
        icon = "&#215;";
        Alertclass = "red";
        Textcolor = "#DC143C";
        break;
      }
      case AlertType.Warning: {
        icon = "&#33;";
        Alertclass = "warn";
        Textcolor = "#FFA809";
        break;
      }
    }

      var Alert: NotificationAlert = new NotificationAlert((Math.random() * 100000).toFixed(0), Title, Message, icon, Alertclass, Textcolor)
      if (AlertMessages.NotArray.length < 1) {
        AlertMessages.SubscribeInterval();
      }
      AlertMessages.NotArray.push(Alert);


  }

  public static SubscribeInterval() {
    AlertMessages.IntervalSubscription = AlertMessages.NotInterval.subscribe(() => {
      if (AlertMessages.NotArray.length < 2) {
        AlertMessages.UnsubscribeInterval();
      }
      AlertMessages.NotArray.splice(0, 1);
    })
  }

  public static UnsubscribeInterval() {
    AlertMessages.IntervalSubscription.unsubscribe();
  }

  /**
   *  for clearing alert list
   */
  public static ClearAlerts() {

    if (AlertMessages.NotArray.length > 0) {
      AlertMessages.NotArray = [];
      AlertMessages.UnsubscribeInterval();
    }
  }

  public static RemoveAlert(Id) {
    if (AlertMessages.NotArray.length < 2) {
      AlertMessages.UnsubscribeInterval();
    }
    var AlertIndex = AlertMessages.NotArray.findIndex(i => i.Id == Id);
    AlertMessages.NotArray.splice(AlertIndex, 1);
  }
}
